import type { RomanApiError } from "@roman/shared/lib/net/romanApi";
import romanApi from "@roman/shared/lib/net/romanApi";
import type { GoogleLoginRequest, GoogleLoginResponse } from "@roman/shared/types/Google";
import useSWRMutation from "swr/mutation";
import { useHandleError } from "../useHandleError";

const fetcher = (url: string, args: { arg: GoogleLoginRequest }) =>
  romanApi.post<GoogleLoginResponse, GoogleLoginRequest>(url, args.arg, { withCredentials: true });

export const useLoginWithGoogle = (
  handleError: (err: RomanApiError) => void = useHandleError("Googleでのログインに失敗しました"),
) => {
  const { trigger } = useSWRMutation(
    "/oauth/google/login",
    (url: string, args: { arg: GoogleLoginRequest }) => fetcher(url, args),
    {
      onError: (error) => {
        handleError(error);
      },
    },
  );
  return {
    trigger,
  };
};
